import Vue from 'vue'
import Vuex from 'vuex'
import Persisted from 'vuex-persistedstate'

import users from './modules/Users'
import loader from './modules/Loader'
import estate from '@/common/store/PatrimonialEstate'
import notifications from '@/common/store/Notifications'
import chat from '@/common/store/Chat'
import documents from '@/common/store/Documents'
import news from '@/common/store/News'
import paymentMethod from '@/common/store/PaymentMethod'
import subscriptions from '@/common/store/Subscriptions'
import site from '@/common/store/Site'
import { STORAGE_KEY } from './state'

Vue.use(Vuex)

const store = new Vuex.Store({
	strict: true,
	plugins: [Persisted({
		key: STORAGE_KEY
	})],
	modules: {
		users,
		loader,
		estate,
		notifications,
		chat,
		documents,
		news,
		paymentMethod,
		subscriptions,
		site
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js